export default __webpack_public_path__ + "static/media/ico-check-white.a990e50d.svg";